import React, { useEffect, useState } from "react"
import { motion } from "framer-motion"
import styled from "styled-components"
const Loader = () => {
  const [loaderHidden, setLoaderHidden] = useState(false)

  useEffect(() => {
    if (localStorage.getItem("init") === null) {
      setTimeout(() => {
        sessionStorage.setItem("init", "init")
        setLoaderHidden(true)
      }, 2000)
    } else {
      setLoaderHidden(true)
    }
  }, [localStorage.getItem("init"), loaderHidden])

  const transition = { duration: 0.5, ease: "easeIn" }

  const list = {
    visible: {
      opacity: 1,
      transition: {
        when: "beforeChildren",
        staggerChildren: 0.1,
      },
    },
    hidden: {
      opacity: 0,
      transition: {
        when: "afterChildren",
      },
    },
  }

  const item = {
    visible: {
      x: 0,
      fill: "white",
      transition: {
        ...transition,
      },
    },
    hidden: {
      x: "-100%",
      fill: "none",
      transition: {
        ...transition,
      },
    },
  }

  return (
    <LoaderContainer show={loaderHidden}>
      <motion.svg
        width={536}
        viewBox="0 0 540 113"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        variants={list}
        initial="hidden"
        animate={loaderHidden ? "visible" : "visible"}
      >
        <svg
          width="541"
          height="113"
          viewBox="0 0 541 113"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <clipPath id="clip-path" transform="translate(0 0)">
              <path
                d="M1 15.3939V16.3939H2H36.783V109.767V110.767H37.783H52.5436H53.5436V109.767V16.3939H88.3266H89.3266V15.3939V2.00002V1.00002H88.3266H2H1V2.00002V15.3939ZM171.838 107.884L171.845 107.888L171.851 107.891C177.363 110.631 183.331 111.998 189.741 111.998C200.659 111.998 209.067 108.966 214.78 102.746C220.578 96.4377 223.393 87.1727 223.393 75.1274V2.00002V1.00002H222.393H207.632H206.632V2.00002V75.8972C206.632 82.9589 205.115 88.1307 202.242 91.5756L202.237 91.5818L202.232 91.5881C199.484 94.993 195.381 96.7584 189.741 96.7584C181.388 96.7584 174.418 92.7195 168.801 84.4199L168.052 83.3138L167.202 84.3435L158.554 94.8122L158.081 95.385L158.493 96.0033C161.869 101.074 166.323 105.037 171.838 107.884ZM251.736 110.767H252.397L252.656 110.158L266.487 77.6669H315.41L329.24 110.158L329.499 110.767H330.16H345.815H347.348L346.731 109.364L299.318 1.59732L299.055 1.00002H298.403H283.642H282.989L282.727 1.59838L235.463 109.365L234.848 110.767H236.379H251.736ZM433.603 110.329L433.901 110.767H434.43H450.681H452.577L451.507 109.202L427.474 74.0722C434.428 71.319 439.87 67.0891 443.755 61.3719C447.863 55.3285 449.892 48.0423 449.892 39.5644C449.892 27.6194 445.922 18.1386 437.915 11.2489C429.929 4.37718 419.035 1.00002 405.356 1.00002H364.653H363.653V2.00002V109.767V110.767H364.653H379.562H380.562V109.767V77.9748H405.356C406.869 77.9748 408.891 77.8843 411.413 77.7059L433.603 110.329ZM425.881 22.4692L425.891 22.4769C430.582 26.3523 432.982 31.9934 432.982 39.5644C432.982 47.1346 430.582 52.8334 425.882 56.8137C421.158 60.8128 414.219 62.8889 404.909 62.8889H380.562V16.3939H404.909C414.219 16.3939 421.158 18.47 425.881 22.4692ZM520.723 110.158L520.982 110.767H521.643H537H538.531L537.916 109.365L490.652 1.59836L490.39 1H489.737H474.976H473.447L474.06 2.40077L500.52 62.8889H474.976H473.976V63.8889V76.6669V77.6669H474.976H506.892L520.723 110.158ZM98.736 110.767H99.3972L99.6561 110.158L113.487 77.6669H145.403H146.403V76.6669V63.8889V62.8889H145.403H119.859L146.319 2.40077L146.932 1H145.403H130.643H129.989L129.727 1.59836L82.4633 109.365L81.8486 110.767H83.3791H98.736ZM272.77 62.8889L290.948 20.253L309.126 62.8889H272.77Z"
                fill="none"
                stroke="white"
                strokeWidth="1"
              />
            </clipPath>
          </defs>
          <path
            d="M1 15.3939V16.3939H2H36.783V109.767V110.767H37.783H52.5436H53.5436V109.767V16.3939H88.3266H89.3266V15.3939V2.00002V1.00002H88.3266H2H1V2.00002V15.3939ZM171.838 107.884L171.845 107.888L171.851 107.891C177.363 110.631 183.331 111.998 189.741 111.998C200.659 111.998 209.067 108.966 214.78 102.746C220.578 96.4377 223.393 87.1727 223.393 75.1274V2.00002V1.00002H222.393H207.632H206.632V2.00002V75.8972C206.632 82.9589 205.115 88.1307 202.242 91.5756L202.237 91.5818L202.232 91.5881C199.484 94.993 195.381 96.7584 189.741 96.7584C181.388 96.7584 174.418 92.7195 168.801 84.4199L168.052 83.3138L167.202 84.3435L158.554 94.8122L158.081 95.385L158.493 96.0033C161.869 101.074 166.323 105.037 171.838 107.884ZM251.736 110.767H252.397L252.656 110.158L266.487 77.6669H315.41L329.24 110.158L329.499 110.767H330.16H345.815H347.348L346.731 109.364L299.318 1.59732L299.055 1.00002H298.403H283.642H282.989L282.727 1.59838L235.463 109.365L234.848 110.767H236.379H251.736ZM433.603 110.329L433.901 110.767H434.43H450.681H452.577L451.507 109.202L427.474 74.0722C434.428 71.319 439.87 67.0891 443.755 61.3719C447.863 55.3285 449.892 48.0423 449.892 39.5644C449.892 27.6194 445.922 18.1386 437.915 11.2489C429.929 4.37718 419.035 1.00002 405.356 1.00002H364.653H363.653V2.00002V109.767V110.767H364.653H379.562H380.562V109.767V77.9748H405.356C406.869 77.9748 408.891 77.8843 411.413 77.7059L433.603 110.329ZM425.881 22.4692L425.891 22.4769C430.582 26.3523 432.982 31.9934 432.982 39.5644C432.982 47.1346 430.582 52.8334 425.882 56.8137C421.158 60.8128 414.219 62.8889 404.909 62.8889H380.562V16.3939H404.909C414.219 16.3939 421.158 18.47 425.881 22.4692ZM520.723 110.158L520.982 110.767H521.643H537H538.531L537.916 109.365L490.652 1.59836L490.39 1H489.737H474.976H473.447L474.06 2.40077L500.52 62.8889H474.976H473.976V63.8889V76.6669V77.6669H474.976H506.892L520.723 110.158ZM98.736 110.767H99.3972L99.6561 110.158L113.487 77.6669H145.403H146.403V76.6669V63.8889V62.8889H145.403H119.859L146.319 2.40077L146.932 1H145.403H130.643H129.989L129.727 1.59836L82.4633 109.365L81.8486 110.767H83.3791H98.736ZM272.77 62.8889L290.948 20.253L309.126 62.8889H272.77Z"
            fill="none"
            stroke="white"
            strokeWidth="1"
            transform="translate(0 0)"
          />
          <g clipPath="url(#clip-path)">
            <motion.rect
              width="100%"
              height="100%"
              fill="none"
              variants={item}
            />
          </g>
        </svg>
      </motion.svg>
    </LoaderContainer>
  )
}

const LoaderContainer = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 6000;
  background: #c33b32;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  opacity: ${props => (props.show ? 0 : 1)};
  visibility: ${props => (props.show ? "hidden" : "visible")};
  transition: all 0.6s ease-in-out;

  svg {
    max-width: 75vw;
  }
`

export default Loader
